export const text = {
  delete: "Delete Document",
};
